//#region IMPORTS
import { getOrderTypeColor } from "../../helpers/getOrderTypeColor";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  orderTypeName: string;
  // Compact variant — matches the status pill size in the instore table.
  small?: boolean;
}
//#endregion

export default function OrderTypeBadge({ orderTypeName, small = false }: Props) {
  //#endregion RENDER
  return (
    <span
      className={classNames(
        getOrderTypeColor(orderTypeName).text,
        getOrderTypeColor(orderTypeName).ring,
        "inline-flex items-center rounded-full font-medium ring-1 ring-inset",
        small
          ? "gap-x-1 px-2 py-0.5 text-[10px]"
          : "gap-x-1.5 px-2.5 py-1 text-xs"
      )}
    >
      <svg
        className={classNames(
          getOrderTypeColor(orderTypeName).fill,
          "h-1.5 w-1.5"
        )}
        viewBox="0 0 6 6"
        aria-hidden="true"
      >
        <circle cx={3} cy={3} r={3} />
      </svg>
      {orderTypeName}
    </span>
  );
  //#endregion
}
